import React from "react";
import oeuf from "./oeuf.png";

const Coin = ({ amount, animated = false }) => {
  return (
    <span className="inline-flex items-center gap-1 sm:gap-2">
      {/* Icône style pièce */}
      <span
        className={`relative w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 inline-flex items-center justify-center ${animated ? "animate-spin-slow" : ""}`}
      >
        <img src={oeuf} alt="coin" className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 object-contain" />
      </span>

      {/* Montants */}
      <span className={`font-bold text-yellow-500 drop-shadow text-xs sm:text-sm md:text-base ${animated ? "animate-pulse" : ""}`}>
        {amount}
      </span>
    </span>
  );
};

export default Coin;
